
import ArrowSquareDown from "../../../assets/outline/ArrowSquareDown.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ArrowSquareDownIcon({ className, dataTestid = "ArrowSquareDownIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <ArrowSquareDown data-testid={dataTestid} className={classes} {...rest} />
  );
}
